import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import Cart from './Cart'
import createPersistedState from 'vuex-persistedstate';


Vue.use(Vuex)

const store = new Vuex.Store({
  	modules: {
    	auth,Cart
  	},
  	plugins: [createPersistedState()],
  	mutations: {
	    //
  	}
})

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js